import * as THREE from "three";
import { useLoader, useThree } from "@react-three/fiber";
import { Html } from "@react-three/drei";
import { useEffect, useState } from "react";

function yawPitchToPosition(yaw, pitch, radius = 500) {
  const phi = THREE.MathUtils.degToRad(90 - pitch);
  const theta = THREE.MathUtils.degToRad(yaw);

  const x = radius * Math.sin(phi) * Math.cos(theta);
  const y = radius * Math.cos(phi);
  const z = radius * Math.sin(phi) * Math.sin(theta);

  return [x, y, z];
}

export default function Panorama({ node, onNavigate }) {
  const { camera } = useThree();
  const [ready, setReady] = useState(false);

  const texture = useLoader(THREE.TextureLoader, node.image);

  texture.wrapS = THREE.RepeatWrapping;
  texture.repeat.x = -1;

  // 🔥 Phantom fix (keep this)
  useEffect(() => {
    setReady(false);

    const id = requestAnimationFrame(() => {
      setReady(true);
    });

    return () => cancelAnimationFrame(id);
  }, [node.image, camera]);

  return (
    <>
      {/* 🌍 Sphere */}
      <mesh key={node.image} scale={[-1, 1, 1]}>
        <sphereGeometry args={[500, 128, 64]} />
        <meshBasicMaterial map={texture} side={THREE.BackSide} />
      </mesh>

      {/* 🔵 Hotspots */}
      {ready &&
        node.hotspots.map((spot, i) => {
          const dynamicRadius =
            500 + (spot.scale ? (1 - spot.scale) * 50 : 0);

          const pos = yawPitchToPosition(
            spot.yaw,
            spot.pitch,
            dynamicRadius
          );

          return (
            <Html key={i} position={pos} center>
              <div
                onClick={() => onNavigate(spot.target)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = `scale(${(spot.scale || 1) * 1.3})`;
                  e.currentTarget.style.background =
                    "rgba(0,150,80,0.85)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = `scale(${spot.scale || 1})`;
                  e.currentTarget.style.background =
                    "rgba(0,0,0,0.6)";
                }}
                style={{
                  width: "40px",
                  height: "40px",
                  background: "rgba(0,0,0,0.6)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  fontSize: "20px",
                  color: "white",
                  transform: `scale(${spot.scale || 1})`,
                  opacity: spot.scale
                    ? Math.min(1, 0.5 + spot.scale / 2)
                    : 1,
                  filter:
                    spot.scale && spot.scale < 0.7
                      ? "blur(1px)"
                      : "none",
                  transition: "all 0.2s ease",
                }}
              >
                ➤
              </div>
            </Html>
          );
        })}
    </>
  );
}